import React, { useEffect } from "react";
import bgvideo from "../video/v2.mp4";
import "./Header.css";
import passportImg from "../images/prm1.jpeg";
function Header() {
  useEffect(() => {
    const hiddenElement = document.querySelectorAll(".hidden");
    // console.log(hiddenElement);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        // console.log(e);
        if (e.isIntersecting) {
          e.target.classList.add("show");
        } else {
          e.target.classList.remove("show");
        }
      });
    });

    hiddenElement.forEach((el) => {
      observer.observe(el);
      // console.log(el);
    });
  }, []);
  return (
    <div className="header">
      <video className="header-video" src={bgvideo} autoPlay muted loop />
      <div className="header-content">
        {/* <nav>.</nav> */}
        <div className="content-body">
          <div className="content-body-left">
            <figure>
              <img src={passportImg} alt="img" />
            </figure>
          </div>
          <div className="content-body-right">
            <p className="hidden">
              Hi, I’m <span className="hover-name">Pijush</span>
            </p>
            <p className="hidden">FRONT-END DEVELOPER</p>
            <div className="ani-transfoem-text" style={{ display: "none" }}>
              <p>and fermented food maker.</p>
              <p>pluviophile.optimist.</p>
              <p>bookworm.</p>
              <p>.superhero movies fan</p>
            </div>
            <div className="quick-link hidden">
              {" "}
              <a href="https://github.com/PIJUSH364">
                <i class="fa-brands fa-github"></i>
              </a>
              <a href="https://www.linkedin.com/in/pijush-ray-mondal-621980192/">
                <i class="fa-brands fa-linkedin"></i>
              </a>
              <a href="https://www.instagram.com/pijushrm_24/">
                <i class="fa-brands fa-instagram"></i>
              </a>
            </div>
            <div className="ani-transfoem-tex hidden">
              I love exploring and creating 🚀 I'm a lifelong learner 🎓 and I
              might have a thing for traditional Neapolitan Pizza 🍕
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
